module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_als_r1"
    }
  }, [_vm._v("ALSO BY TAMAS DOBOZY")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_epi_r1"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c01_r1"
    }
  }, [_vm._v("The Atlas of B. Görbe")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c02_r1"
    }
  }, [_vm._v("The Animals of the Budapest Zoo, 1944–1945")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailor’s Mouth")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Restoration of the Villa Where Tíbor Kálmán Once Lived")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beautician")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c05_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Days of Orphans and Strangers")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosewood Queens")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Encirclement")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Society of Friends")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Miracles of Saint Marx")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Selected Mug Shots of Famous Hungarian Assassins")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghosts of Budapest and Toronto")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Homemade Doomsday Machine")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/tama_9781571318879_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb92d6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tama_9781571318879_oeb_toc_r1.vue
// module id = 63
// module chunks = 0